<template>
  <div v-if="dropboxLink" class="dropboxvideo-container">
    <video
      autoplay
      controls
      disablePictureInPicture
      controlsList="nodownload"
      height="100%"
    >
      <source :src="dropboxLink" type="video/mp4" />
      Twoja przeglądarka nie obsługuje wideo.
    </video>
  </div>
  <div
    v-else-if="youtubeVideoId"
    :id="resourceId ? `yt-player-${resourceId}` : youtubeVideoId"
    class="yt-player"
    data-plyr-provider="youtube"
    :data-plyr-embed-id="youtubeVideoId"
    style="width: 100%; height: 100%"
  />
</template>

<script>
import Plyr from "plyr";
export default {
  props: {
    videoId: String,
    resourceId: String,
    dropboxLink: String,
  },
  mounted() {
    setTimeout(() => {
      this.player = null;
      if (this.resourceId) {
        this.player = new Plyr(`#yt-player-${this.resourceId}`, {
          controls: [
            "play-large",
            "rewind",
            "play",
            "fast-forward",
            "progress",
            "current-time",
            "duration",
            "mute",
            "volume",
            "settings",
            "fullscreen",
          ],
        });
      } else {
        this.player = new Plyr(".yt-player", {
          controls: [
            "play-large",
            "rewind",
            "play",
            "fast-forward",
            "progress",
            "current-time",
            "duration",
            "mute",
            "volume",
            "settings",
            "fullscreen",
          ],
        });
      }
    }, 500);
  },
  data() {
    return {
      player: null,
    };
  },
  computed: {
    youtubeVideoId() {
      if (!this.videoId) return null;

      // Jeśli to już samo ID (bez http), zwróć je
      if (!this.videoId.includes("http")) {
        return this.videoId;
      }

      // Wyciągnij ID z różnych formatów URL YouTube
      // Format: https://youtu.be/FCUWk_9gkK8
      const youtuBeMatch = this.videoId.match(/youtu\.be\/([^?&]+)/);
      if (youtuBeMatch) {
        return youtuBeMatch[1];
      }

      // Format: https://www.youtube.com/watch?v=FCUWk_9gkK8
      const watchMatch = this.videoId.match(/[?&]v=([^?&]+)/);
      if (watchMatch) {
        return watchMatch[1];
      }

      // Format: https://www.youtube.com/embed/FCUWk_9gkK8
      const embedMatch = this.videoId.match(/embed\/([^?&]+)/);
      if (embedMatch) {
        return embedMatch[1];
      }

      // Jeśli nie rozpoznano formatu, zwróć oryginalne ID
      return this.videoId;
    },
  },
};
</script>

<style scoped>
.dropboxvideo-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

video {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}
</style>
